module.exports = __webpack_public_path__ + "static/media/icon.ee749442.png";